import { clientData } from "./GetClient";

export const FormatAmount = (amount) => {
  if (amount === undefined || amount === null || isNaN(amount)) {
    return amount ?? "-";
  }

  const currencySymbol = clientData?.currency_symbol || "$";
  const formattedNumber = Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${currencySymbol}${formattedNumber}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  } catch (e) {
    return dateString;
  }
};

export default FormatAmount;
